var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackToStart = function SvgBackToStart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9942 16.0395L14.5453 17.3906L9.03711 11.8824L14.668 6.25146L16.0941 7.62543L12.8371 10.8824L22.0371 10.8824V12.8824L12.8371 12.8824L15.9942 16.0395Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 13.6569 5.65685 15 4 15C2.34315 15 1 13.6569 1 12C1 10.3432 2.34315 9.00001 4 9.00001C5.65685 9.00001 7 10.3432 7 12Z",
    fill: "currentcolor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackToStart);
export default ForwardRef;